import { Box, Center, Group, SimpleGrid, Space, Text } from "@mantine/core"
import { DefaultLayout } from "../../components/DefaultLayout/DefaultLayout"
import QXOLogo from '../../assets/partner-logos/qxo-logo.png';
import EightFourLumberLogo from '../../assets/partner-logos/eightfour-lumber-logo.webp';
import RomaTileLogo from '../../assets/partner-logos/roma-tile-logo.png';
import AzekLogo from '../../assets/partner-logos/azek-logo.png';
import TimbertechLogo from '../../assets/partner-logos/timbertech-logo.png';
import SoundRiskManagementLogo from '../../assets/partner-logos/sound-risk-management-corp.png';
import SouthShoreSwagLogo from '../../assets/partner-logos/south-shore-swag-logo.jpeg';
import MrsElectricLogo from '../../assets/partner-logos/mrs-electric-logo.png';
import '../LandingPage/LandingPageStyle.css';

export const MemberBenefitsPage = () : JSX.Element => {

    return (
        <DefaultLayout showNavBar={true} showSearchBar={false} showFooter={true}>
            <div className="about-hero-bleed">
                <div className="about-hero-container">
                    <Box pt={'6em'} pb={'6em'} pl={'1em'} pr={'1em'}>
                        <Center>
                            <Text ta={'center'} c="#1F2937" fw={'bold'} visibleFrom="md" fz={44}>Member Benefits</Text>
                            <Text ta={'center'} c="#1F2937" fw={'bold'} hiddenFrom="md" fz={30}>Member Benefits</Text>
                        </Center>
                        <Center>
                            <Text ta={'center'} c={'#4B5563'}>Our members gain access to supplier discounts, business services, networking opportunities, and resources designed to help contractors grow smarter and more profitable. All for free.</Text>
                        </Center>
                    </Box>
                </div>
            </div>
            {/* Partners Section */}
            <Box className="benefits-section">
                <Space h="4em" />
                <Center pl="10%" pr="10%">
                    <Text hiddenFrom="md" c="#1F2937" ta="center" fz={30} fw="bold">Partners</Text>
                    <Text visibleFrom="md" c="#1F2937" ta="center" fz={44} fw="bold">Partners</Text>
                </Center>
                <Center>
                    <Text c="#5d636f" ta="center" pl={'10%'} pr={'10%'}>Our network of suppliers and professional services</Text>
                </Center>
                <Space h="4em" />
                <SimpleGrid ml={'5%'} mr={'5%'} cols={{ base: 2, md: 4 }} spacing="xl" style={{ alignItems: 'stretch' }}>
                    <Box className="hover-shadow" p="sm" style={{ borderRadius: '1em', border: '1px solid rgba(136, 137, 138, 0.2)', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '120px' }}>
                        <img src={QXOLogo} style={{ maxWidth: '100%', height: '70px', objectFit: 'contain' }} />
                    </Box>
                    <Box className="hover-shadow" p="sm" style={{ borderRadius: '1em', border: '1px solid rgba(136, 137, 138, 0.2)', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '120px' }}>
                        <img src={EightFourLumberLogo} style={{ maxWidth: '100%', height: '70px', objectFit: 'contain' }} />
                    </Box>
                    <Box className="hover-shadow" p="sm" style={{ borderRadius: '1em', border: '1px solid rgba(136, 137, 138, 0.2)', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '120px' }}>
                        <img src={RomaTileLogo} style={{ maxWidth: '100%', height: '120px', objectFit: 'contain' }} />
                    </Box>
                    <Box className="hover-shadow" p="sm" style={{ borderRadius: '1em', border: '1px solid rgba(136, 137, 138, 0.2)', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '120px' }}>
                        <img src={AzekLogo} style={{ maxWidth: '100%', height: '70px', objectFit: 'contain' }} />
                    </Box>
                    <Box className="hover-shadow" p="sm" style={{ borderRadius: '1em', border: '1px solid rgba(136, 137, 138, 0.2)', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '120px' }}>
                        <img src={TimbertechLogo} style={{ maxWidth: '100%', height: '120px', objectFit: 'contain' }} />
                    </Box>
                    <Box className="hover-shadow" p="sm" style={{ borderRadius: '1em', border: '1px solid rgba(136, 137, 138, 0.2)', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '120px' }}>
                        <img src={SoundRiskManagementLogo} style={{ maxWidth: '100%', height: '80px', objectFit: 'contain' }} />
                    </Box>
                    <Box className="hover-shadow" p="sm" style={{ borderRadius: '1em', border: '1px solid rgba(136, 137, 138, 0.2)', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '120px' }}>
                        <img src={SouthShoreSwagLogo} style={{ maxWidth: '100%', height: '100px', objectFit: 'contain' }} />
                    </Box>
                    <Box className="hover-shadow" p="sm" style={{ borderRadius: '1em', border: '1px solid rgba(136, 137, 138, 0.2)', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '120px' }}>
                        <img src={MrsElectricLogo} style={{ maxWidth: '100%', height: '90px', objectFit: 'contain' }} />
                    </Box>
                </SimpleGrid>
                <Space h="2em" />
                <Center>
                    <Group gap="xs">
                        <Text c="#5d636f" fz={14}>New partnerships added monthly</Text>
                        <Text c="#cc7800" fz={14}>
                            <span className="coming-soon-dot">•</span>
                            <span className="coming-soon-dot">•</span>
                            <span className="coming-soon-dot">•</span>
                        </Text>
                    </Group>
                </Center>
                <Space h="8em" />
            </Box>
        </DefaultLayout>
    )
}
